export const SEARCH_DEBOUNCE_MS = 350;
export const MIN_SEARCH_LENGTH = 3;
